import { render, staticRenderFns } from "./activeInfo.vue?vue&type=template&id=a21011e2&scoped=true&"
import script from "./activeInfo.vue?vue&type=script&lang=js&"
export * from "./activeInfo.vue?vue&type=script&lang=js&"
import style0 from "./activeInfo.vue?vue&type=style&index=0&id=a21011e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21011e2",
  null
  
)

export default component.exports